import React from 'react'
import { Box } from '@mui/material'
import { alpha, useTheme } from '@mui/material/styles'

import withCapabilities from '../../hoc/withCapabilities'
import { PAGE_BOTTOM_PADDING, PAGE_MAX_WIDTH, PAGE_TOP_PADDING, PAGE_WIDTH } from '../../theme'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import BrandingThemeProvider from '../BrandingThemeProvider/BrandingThemeProvider'
import { useScrollToHash } from '../../hooks/useScrollToHash'

const CustomerPageLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const theme = useTheme()
  const imageSkeletonColor = theme.palette.branding.enabled
    ? alpha(theme.palette.getContrastText(theme.palette.branding.pageBackground), 0.08)
    : theme.palette.background.light

  return (
    <Box
      sx={{
        '--image-skeleton-color': imageSkeletonColor,
        backgroundColor: theme.palette.branding.pageBackground,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header />
      <Box
        id="main"
        sx={{
          pt: PAGE_TOP_PADDING,
          pb: PAGE_BOTTOM_PADDING,
          width: PAGE_WIDTH,
          maxWidth: PAGE_MAX_WIDTH,
          margin: '0 auto',
          boxSizing: 'border-box',
          flexGrow: 1,
          minWidth: 0,
        }}
      >
        {children}
      </Box>
      <Footer />
    </Box>
  )
}

const CustomerPageTemplate: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  useScrollToHash()

  return (
    <BrandingThemeProvider>
      <CustomerPageLayout>{children}</CustomerPageLayout>
    </BrandingThemeProvider>
  )
}

export default withCapabilities(CustomerPageTemplate)
